export default __webpack_public_path__ + "static/christmas-logo-48886f4dccbec092bcdd4befe8604a54.svg";